import * as types from "../../constants";
import { actions as performAction } from "../../services/customerBusinessService";

export function actions(credentials) {
  const { action } = credentials;
  return async (dispatch) => {
    dispatch({ type: types.PROCESSORS_RESTART_RESPONSE });
    switch (action) {
      case "list":
        dispatch({ type: types.PROCESSORS_LIST_REQUEST });
        break;
    }

    return performAction(credentials)
      .then((response) => {
        console.log("actions " + action + " processors");
        console.log(response);
        switch (action) {
          case "list":
            dispatch({
              type: types.PROCESSORS_LIST_SUCCESS,
              response,
            });
            break;
        }
      })
      .catch((error) => {
        switch (action) {
          case "list":
            dispatch({ type: types.PROCESSORS_LIST_FAILURE });
            break;
        }
        throw error;
      });
  };
}
